import Model from '../utils/Model'
class PaymentMethod {
  constructor(code, chineseName, englishName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}

export const CODE_NAME = 'PaymentMethod'

export const PREPORT_PAYMENT = new PaymentMethod('PREPORT_PAYMENT', '口岸前付款', 'Pre-Port Payment')
export const DEPART_PAYMENT = new PaymentMethod('DEPART_PAYMENT', '发车付款', 'Depart Payment')
export const CREDIT_PAYMENT = new PaymentMethod('CREDIT_PAYMENT', '信控放款', 'Credit Payment')

export const PAYMENTMETHOD_TYPES = [PREPORT_PAYMENT, DEPART_PAYMENT, CREDIT_PAYMENT]

/**
		 *  return null:没找到.
		 */
export function getPaymentMethodByCode(code) {
  return Model.getObjByCode(code, PAYMENTMETHOD_TYPES)
}

/**
		 *  return null:没找到.
		 */
export function getPaymentMethodByBusType(code, arrs) {
  return Model.getObjByCode(code, arrs)
}

